import React, { ReactElement, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { isMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { RootState } from 'reactApp/store';
import { createGaSender } from 'reactApp/utils/ga';

import { getContent, getTitle } from './RemoveDialog.helpers';
import { IProps } from './RemoveDialog.types';

const sendGa = createGaSender(`remove-dialog`);

export const RemoveDialog = React.memo(function RemoveDialog(props: IProps): ReactElement {
    const [loading, setLoading] = useState<boolean>(false);
    const { items, hasAlienFiles, onRemove } = props;

    const item = items[0];
    const { isMounted, isDomain } = useSelector((state: RootState) => isMountedOrSharedFolder(state, item));
    const currentStorage = useSelector(getCurrentStorage);

    const onConfirm = useCallback(() => {
        setLoading(true);
        sendGa('confirm');
        onRemove();
    }, [onRemove]);

    const onClose = useCallback(() => {
        sendGa('close');
        props.onClose?.();
    }, [props]);

    const renderHeader = useCallback(() => <>{getTitle(items)}</>, [items]);

    const renderContent = useCallback(
        () => getContent({ isMounted: isMounted && !isDomain, items, hasAlienFiles, currentStorage }),
        [isDomain, isMounted, items, hasAlienFiles]
    );
    const buttons = useMemo(() => (items.length ? [EButtonType.accept, EButtonType.cancel] : [EButtonType.cancel]), [items.length]);

    useEffect(() => sendGa('show'), []);

    return (
        <BaseConfirmDialog
            dataQAId="remove-confirmation-dialog"
            renderHeader={renderHeader}
            successButtonText="Удалить"
            cancelButtonText="Отменить"
            buttons={buttons}
            onClose={onClose}
            onSuccess={onConfirm}
            renderContent={renderContent}
            loading={loading}
            closeOnDimmerClick
        />
    );
});
